import type { Permission } from '@/schemas/auth/auth.schemas';

/**
 * Check whether a permission set grants the required permission.
 * The admin permission grants everything.
 */
export function hasEffectivePermission(
  userPermissions: Permission[],
  required: Permission
): boolean {
  if (userPermissions.includes('admin')) {
    return true;
  }
  return userPermissions.includes(required);
}

/**
 * Check whether a permission set grants at least one of the required
 * permissions (any-match). Accepts a single permission too, so callers
 * gating on either one permission or a list can share this helper.
 */
export function hasAnyEffectivePermission(
  userPermissions: Permission[],
  required: Permission | Permission[]
): boolean {
  const list = Array.isArray(required) ? required : [required];
  return list.some(p => hasEffectivePermission(userPermissions, p));
}
